export default __webpack_public_path__ + "static/media/TL14.0c38e9bb.mp3";